<template>
  <v-container class="s2" fluid>
    <v-container class="sinner">
      <img src="@/assets/images/citation.png" class="simg">
      <p class="pt-8 pb-4">
        <i>{{text}}</i> - {{author}}
      </p>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "Citation",
  props:{
    text:String,
    author:String,
  }
}
</script>

<style scoped>
.sinner{
  position: relative;
}
.simg{
  position:absolute;
  top:-40px;
  left:40px;
  width:70px;
}
.s2{
  background-color: #1976d2;
  font-size: 24pt;
  color: white;
  text-align: center;

}
@media screen and (max-width: 600px) {
  .s2{
    font-size: 16pt;
    clear: both;
    margin-top: 0px;
  }
}
</style>